import React from "react";
import dynamic from "next/dynamic";
import LocationConfirm from "@components/Features/MainPage/LocationConfirm/LocationConfirm";
import { ExpanderIcon } from "@components/Svg";
import LocationButton from "@components/UI/Buttons/LocationButton/LocationButton";
import { BREAKPOINT_EXPANDED } from "./constants";
import { MainFilterHeaderProps } from "./types";
import classes from "./MainFilter.module.scss";

const DynamicLocationFilter = dynamic(
    () => import("@components/Features/MainPage/LocationFilter/LocationFilter"),
    {
        ssr: false
    }
);

const MainFilterHeader: React.FC<MainFilterHeaderProps> = ({
    isLocationFilterShown,
    setIsLocationFilterShown,
    isLocationConfirmShown,
    setIsLocationConfirmShown,
    isExpanded,
    setIsExpanded,
    targetExpandedRef
}) => {
    const handleChangeLocation = () => {
        setIsLocationConfirmShown(false);
        setIsLocationFilterShown(true);
    };

    const handleExpandClick = () => {
        setIsExpanded(!isExpanded);

        if (!isExpanded && window.innerWidth <= BREAKPOINT_EXPANDED && targetExpandedRef.current) {
            targetExpandedRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    };

    return (
        <div className={classes.Header}>
            <div className={classes.CitySelector}>
                <LocationButton
                    onClick={() => {
                        setIsLocationFilterShown(!isLocationFilterShown);
                        setIsLocationConfirmShown(false);
                    }}
                    isConfirmShown={isLocationConfirmShown}
                />
            </div>
            {isLocationConfirmShown && (
                <div className={classes.LocationConfirmCont}>
                    <LocationConfirm
                        onClose={() => {
                            setIsLocationConfirmShown(false);
                        }}
                        onChange={handleChangeLocation}
                    />
                </div>
            )}
            {isLocationFilterShown && (
                <div className={classes.LocationFilterCont}>
                    <DynamicLocationFilter
                        onClose={() => {
                            setIsLocationFilterShown(false);
                        }}
                    />
                </div>
            )}
            <div
                className={`${classes.ModeSwitcher} ${isExpanded ? classes.Expanded : ""}`}
                onClick={handleExpandClick}
            >
                Расширенный поиск <ExpanderIcon expanded={isExpanded} />
            </div>
        </div>
    );
};

export default MainFilterHeader;